/**
 * LMB (Liga Mexicana de Beisbol) Theme Configuration
 * Brand colors: Red, Light Green, Black - Mexican baseball league colors
 */

const lmbTheme = {
    // Client identification
    clientId: 'lmb',
    clientName: 'Liga Mexicana de Beisbol',

    // Logo configuration - TODO: Add LMB logo
    logos: {
        primary: require('../../components/Login/images/lmb.png'),
        primaryHeight: '85px',
        secondary: require('../../components/Login/images/theteam.png'),
        secondaryHeight: '52px',
    },

    // Channel colors and gradients - Red/Green baseball palette
    channels: {
        social: {
            color: '#E31937',  // LMB Red
            gradient: ['#FF6B6B', '#E31937'],
        },
        digital: {
            color: '#00A651',  // LMB Green
            colorHex: '#00A651',
            gradient: ['#4DD68B', '#00A651'],
        },
        highlights: {
            color: '#FFB800',  // Gold/Yellow accent
            gradient: ['#FFD54F', '#FFC107'],
        },
        linear: {
            color: '#4DD0E1',
            colorAlt: '#00897B',
            gradient: ['#80DEEA', '#4DD0E1'],
        },
        tv: {
            color: '#00897B',
            gradient: ['#4DB6AC', '#26A69A'],
        },
        invenue: {
            color: '#00897B',
            gradient: ['#4DB6AC', '#26A69A'],
        },
        ooh: {
            color: '#7B1FA2',
            gradient: ['#BA68C8', '#AB47BC'],
        },
        sponsorship: {
            color: '#8BC34A',
            gradient: ['#AED581', '#8BC34A'],
        },
    },

    // Gradient card text color
    gradientCardText: 'black',

    // Background colors - Black/dark theme (LMB black element)
    backgrounds: {
        page: '#0A0A0A',
        loginPage: 'rgb(12, 12, 12)',
        panel: '#141414',
        panelDark: 'hsl(0 0% 6%)',
        panelMid: 'hsl(0 0% 11%)',
        panelAlt: 'hsl(0 0% 15%)',
        panelLight: 'hsl(0 0% 20%)',
        modal: '#1F1F1F',
    },

    // Text colors
    text: {
        primary: 'white',
        secondary: '#4DD68B',  // Light green
        highlight: '#00E676',
        onLight: '#1A1A1A',
        link: '#4DD0E1',
        wheat: '#E8E8E8',
    },

    // Button colors - must use Semantic UI color names
    buttons: {
        primary: 'green',
        dashboard: 'red',
        viz3d: 'teal',
        rawdata: 'grey',
        apply: 'green',
        save: 'olive',
        reset: 'red',
        refresh: 'teal',
    },

    // Accent colors - Red and green (primary must be Semantic UI color name for Label)
    accents: {
        primary: 'red',    // LMB red for high contrast
        secondary: '#00A651',
        tertiary: '#FFB800',
        tab1: '#E31937',
        tab2: '#00A651',
        tab3: '#FFB800',
    },

    // Navigation colors
    navigation: {
        background: '#0A0A0A',
        iconColor: '#4DB6AC',
        iconActiveColor: '#00E676',
        iconHighlight: '#E31937',
    },

    // Label colors - must use Semantic UI color names for ribbon to work
    labels: {
        brand: 'green',    // Avg label - LMB green
        asset: 'red',      // Progress bar - LMB red, different from brand
        channel: 'teal',
        comparison: 'green',
        ribbon: 'red',
    },

    // Shadow styles - Neutral dark
    shadows: {
        card: 'hsl(0 0% 18%) 0 0 4px',
        cardLarge: 'hsl(0 0% 18%) 0 0 8px',
        image: '#050505 9px 10px 20px 2px',
    },

    // Gauge/Speedometer colors
    gauge: {
        stages: [
            [0.09, '#E31937'],
            [0.25, '#FF5252'],
            [0.45, '#FFB800'],
            [0.7, '#4DD0E1'],
            [1, '#00E676'],
        ],
        text: '#fff',
        detail: '#1F1F1F',
        shadow: '#00E676',
    },

    // Table row color palette - Dark neutral with red/green accents
    tableRows: [
        '#141414',
        '#1F1F1F',
        '#2A2A2A',
        '#1A3D2A',  // Dark green tint
        '#3D1A1A',  // Dark red tint
        '#2E4A3A',
        '#4A2E2E',
        '#1E3E2E',
        '#3E1E1E',
        '#2A4A3A',
        '#4A2A2A',
        '#1F3F2F',
        '#3F1F1F',
    ],

    // Form element colors
    forms: {
        loginFormBackground: '#0A0A0A',
        loginFormOpacity: '0.85',
        dropdownBackground: '#00A651',
        dropdownText: 'white',
        inputBackground: '#1F1F1F',
        inputText: '#00E676',
    },

    // Progress bar colors - red fill on dark for high contrast
    progressBar: {
        background: 'hsl(0 0% 20%)',
        fill: '#E31937',  // LMB red for visibility
        tiny: '#1F1F1F',
    },

    // Scrollbar colors
    scrollbar: {
        track: '#141414',
        thumb: '#1F1F1F',
    },

    // Chart-specific colors
    charts: {
        axisLabel: '#888888',
        axisLine: 'white',
        tooltipBackground: '#1F1F1F',
    },
};

export default lmbTheme;
